import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Link } from 'gatsby';
import _ from 'lodash';

const Hero = ({ post, coverImage }) => {
  const { frontmatter, timeToRead } = post;
  const { title, excerpt, date, tag } = frontmatter;
  const tagSlug = `/tag/${_.kebabCase(tag)}`;
  // TODO: link the tag
  return (
    <HeroWrapper>
      <Header>
        {tag && <Tag to={tagSlug}>{tag}</Tag>}
        <Title>{title}</Title>
        <Excerpt>{excerpt}</Excerpt>
        <Subtitle>
          {date}
          {timeToRead && ` · ${timeToRead} min read`}
        </Subtitle>
      </Header>
      <ImageWrapper id={'Hero__CoverImage'}>
        {coverImage && (
          <Image
            image={coverImage.childImageSharp.gatsbyImageData}
            alt={coverImage.name}
          />
        )}
      </ImageWrapper>
    </HeroWrapper>
  );
};

const HeroWrapper = styled.div`
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    &::before {
      content: '';
      width: 100%;
      height: 20px;
      position: absolute;
      left: 0;
      top: 0;
    }
    &::after {
      content: '';
      width: 100%;
      height: 10px;
      position: absolute;
      left: 0;
      top: 10px;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
    }
  }
`;

const Header = styled.div`
  position: relative;
  z-index: 10;
  // margin: 60px auto 120px;
  margin: 60px auto 80px;
  padding-left: 68px;
  max-width: 749px;

  @media (max-width: ${(p) => p.theme.screen.lg}) {
    padding-left: 53px;
    max-width: calc(507px + 53px);
    margin: 60px auto 30px;
  }

  @media (max-width: ${(p) => p.theme.screen.md}) {
    padding-left: 0;
    margin: 60px auto 30px;
    max-width: 480px;
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    padding: 0 40px;
  }

  @media screen and (max-height: 700px) {
    margin: 100px auto;
  }
`;

const Tag = styled(Link)`
  display: block;
  font-family: ${(p) => p.theme.font.markdown};
  font-size: 0.9rem;
  line-height: 1em;
  font-weight: 600;
  color: ${(p) => p.theme.color.font.link};
  transition: color 0.3s ease-in-out;
  text-transform: uppercase;
  text-decoration: none;
  margin-bottom: 15px;
`;

const Title = styled.h1`
  font-weight: bold;
  margin-bottom: 25px;

  @media (max-width: ${(p) => p.theme.screen.md}) {
    margin-bottom: 20px;
    font-size: 36px;
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    font-size: 32px;
  }
`;

const Excerpt = styled.p`
  font-family: ${(p) => p.theme.font.markdown};
  color: ${(p) => p.theme.color.font.regular};
  line-height: 1.756;
  font-size: 18px;
  margin-bottom: 20px;
`;

const Subtitle = styled.span`
  display: block;
  font-family: ${(props) => props.theme.font.markdown};
  ${(props) => props.theme.font_size.xsmall};
  color: ${(props) => props.theme.color.font.regular};
  opacity: 0.4;
  // padding: 15px 0;
  // border-top: 1px solid ${(p) => p.theme.color.trackline};
`;

const ImageWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 944px;
  max-height: 440px;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.2),
    0 18px 36px -18px rgba(0, 0, 0, 0.22);

  @media (max-width: ${(p) => p.theme.screen.lg}) {
    left: calc((960px - 32px - 100vw) / 2);
    max-width: none;
    width: 100vw;
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    left: calc((720px - 32px - 100vw) / 2);
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    left: auto;
    max-width: 100%;
    margin: 0 auto;
    width: calc(100vw - 40px);
    max-height: 220px;
    & > div {
      height: 220px;
    }
  }
`;

const Image = styled(GatsbyImage)`
  & > img {
    filter: blur(8px);
  }
`;

export default Hero;
